import { render, staticRenderFns } from "./costStatistics.vue?vue&type=template&id=54ac858d&scoped=true&"
import script from "./costStatistics.vue?vue&type=script&lang=js&"
export * from "./costStatistics.vue?vue&type=script&lang=js&"
import style0 from "./costStatistics.vue?vue&type=style&index=0&id=54ac858d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ac858d",
  null
  
)

export default component.exports